import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit", "input"];
  connect() {
    this.toggleSaveButton();
  }

  attachFile() {
    this.submitTarget.disabled = false;
  }
  
  toggleSaveButton() {
    const fileInput = document.getElementById("file-upload");
    const saveButton = document.getElementById("save-button");
    const radioButtons = document.querySelectorAll("input[name='list-type']");
    const downloadBtn = document.querySelector("#download-template-btn");
    
    if (!fileInput || !saveButton) return;
    
    const isFileSelected = fileInput.files.length > 0;
    const isRadioSelected = Array.from(radioButtons).some(radio => radio.checked);
    const selectedRadio = Array.from(radioButtons).find(radio => radio.checked);

    saveButton.disabled = !(isFileSelected && isRadioSelected);

    if (downloadBtn) {
      if (selectedRadio) {
        downloadBtn.classList.remove("disabled");
        downloadBtn.removeAttribute("disabled");

        if (selectedRadio.value === "standard") {
          downloadBtn.href = downloadBtn.getAttribute("data-standard-template");
          downloadBtn.setAttribute("download", "exhibitors-template-standard.xlsx");
        } else if (selectedRadio.value === "hpma") {
          downloadBtn.href = downloadBtn.getAttribute("data-hpma-template");
          downloadBtn.setAttribute("download", "exhibitors-template-hpma.xlsx");
        }
      } else {
        downloadBtn.classList.add("disabled");
        downloadBtn.setAttribute("disabled", true);
        downloadBtn.removeAttribute("href");
        downloadBtn.removeAttribute("download");
      }
    }
  }
}
